import { Component, HostBinding, inject } from '@angular/core';
import { MainMenuStateService } from '../../services/main-menu-state.service';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrl: './analytics.component.scss',
  standalone: false,
})
export class AnalyticsComponent {
  private readonly menuState = inject(MainMenuStateService);

  @HostBinding('style.width') get width() {
    const mainMenuOffset = this.menuState.isExpanded()
      ? px2Rem(220)
      : px2Rem(60);
    return 'calc(100% - ' + `${mainMenuOffset}rem)`;
  }
}
